import axios from "axios";
// import { i18n } from "@/services/i18n/i18n";
import {
  typesenseNodeUrl,
  typesenseReadonlyApiKey,
} from "@/services/utils/utils";

const axiosInstance = axios.create({
  baseURL: typesenseNodeUrl,

  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-TYPESENSE-API-KEY": typesenseReadonlyApiKey,
  },

  withCredentials: false,
});

export const client = axiosInstance;
